<template>
  <McEmptyState
    :title="title"
    :desc="desc"
    :buttonText="buttonText"
    :buttonTextSecondary="buttonTextSecondary"
    :img="img"
    :buttonIco="buttonIco"
    @buttonPrimaryAction="buttonPrimaryAction()"
    @buttonSecondaryAction="buttonSecondaryAction()"
  ></McEmptyState>
</template>
<script>
import McEmptyState from './index'

export default {
  components: {
    McEmptyState,
  },

  props: {
    img: {
      type: String,
      default: require('@/assets/images/nodata.png'),
      required: false,
    },

    title: {
      type: String,
      required: true,
    },

    desc: {
      type: String,
      required: false,
    },

    buttonText: {
      type: String,
      default: 'Tambah',
      required: false,
    },

    buttonTextSecondary: {
      type: String,
      required: false,
    },

    buttonIco: {
      type: String,
      default: 'icon-outline_plus',
      required: false,
    },
  },

  methods: {
    buttonPrimaryAction() {
      alert('Button Primary Active')
    },

    buttonSecondaryAction() {
      alert('Button Secondary Active')
    },
  },
}
</script>
